import { render, staticRenderFns } from "./LottoResults.vue?vue&type=template&id=c4f1225e"
import script from "./LottoResults.vue?vue&type=script&lang=js"
export * from "./LottoResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports